import { useState, useEffect } from "react";
import { Loader2, Trash2, MailOpen, CheckCircle } from "lucide-react";

const AdminContactList = () => {
  const [messages, setMessages] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // const backendUrl = "http://localhost/seva-backend"; // Apna port
  const backendUrl = "https://www.sevaafoundation.com/seva-backend"; // Apna port
  const token = localStorage.getItem("sevaa_admin_token");

  const fetchMessages = async () => {
    try {
     const res = await fetch(`${backendUrl}/api/contact/all.php`, {
        headers: { "Authorization": `Bearer ${token}` } // Ye header add kiya
      });
      const data = await res.json();
      if (data.success) {
        setMessages(data.messages);
      }
    } catch (error) {
      console.error("Failed to fetch messages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const handleStatusChange = async (id: number, newStatus: string) => {
    try {
     const res = await fetch(`${backendUrl}/api/contact/update_status.php?id=${id}`, {
        method: "PUT",
        headers: { 
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}` // Ye header add kiya
        },
        body: JSON.stringify({ status: newStatus }),
      });
      const data = await res.json();
      if (data.success) {
        setMessages(prev => prev.map(m => m.id === id ? { ...m, status: newStatus } : m));
      }
    } catch (error) {
      console.error("Failed to update status");
    }
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure you want to delete this message?")) return;
    try {
     const res = await fetch(`${backendUrl}/api/contact/delete.php?id=${id}`, { 
          method: "DELETE",
          headers: { "Authorization": `Bearer ${token}` } // Ye header add kiya
      });
      const data = await res.json();
      if (data.success) {
        setMessages(prev => prev.filter(m => m.id !== id));
      }
    } catch (error) {
      console.error("Failed to delete record");
    }
  };

  if (isLoading) return <div className="p-8 text-center"><Loader2 className="animate-spin mx-auto text-teal-600" size={32} /></div>;

  return (
    <div className="p-8 font-poppins">
      <h2 className="text-3xl font-bold mb-6 text-slate-800">Contact Inquiries</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {messages.length === 0 && <p className="text-slate-500 col-span-full">No messages found.</p>}
        
        {messages.map((msg) => (
          <div key={msg.id} className={`bg-white rounded-2xl p-6 shadow-sm border ${msg.status === 'Unread' ? 'border-orange-200 bg-orange-50/30' : 'border-slate-200'} relative`}>
            
            {/* Status Badge */}
            <span className={`absolute top-4 right-4 text-[10px] uppercase font-bold tracking-widest px-2.5 py-1 rounded-full ${
                msg.status === 'Unread' ? 'bg-orange-100 text-orange-600' :
                msg.status === 'Resolved' ? 'bg-green-100 text-green-600' :
                'bg-blue-100 text-blue-600'
            }`}>
                {msg.status}
            </span>

            <h4 className="font-black text-slate-800 text-lg pr-20">{msg.subject}</h4>
            <p className="text-sm font-medium text-slate-500 mb-4">{msg.name} ({msg.email})</p>
            
            <div className="bg-slate-50 p-4 rounded-xl text-sm text-slate-700 leading-relaxed mb-4 min-h-[100px] border border-slate-100">
                {msg.message}
            </div>
            
            <div className="flex justify-between items-center mt-auto border-t border-slate-100 pt-4">
                <p className="text-xs text-slate-400 font-medium">{new Date(msg.created_at).toLocaleDateString()}</p>
                
                <div className="flex gap-2">
                    {msg.status === 'Unread' && (
                        <button onClick={() => handleStatusChange(msg.id, 'Read')} className="p-1.5 text-blue-500 hover:bg-blue-50 rounded" title="Mark as Read">
                            <MailOpen size={18} />
                        </button>
                    )}
                    {msg.status !== 'Resolved' && (
                        <button onClick={() => handleStatusChange(msg.id, 'Resolved')} className="p-1.5 text-emerald-500 hover:bg-emerald-50 rounded" title="Mark as Resolved">
                            <CheckCircle size={18} />
                        </button>
                    )}
                    <button onClick={() => handleDelete(msg.id)} className="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded ml-2" title="Delete Message">
                        <Trash2 size={18} />
                    </button>
                </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminContactList;